import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

import useDateOptions from "@/features/FilterTable/useDateOptions";

const filterA7OPCVMClientPortfoliosSchema = z.object({
  date_equals: z.string().optional(),
  denomination_fonds_contains: z.string().optional(),
  scope_contains: z.string().optional(),
  vehicle_contains: z.string().optional(),
});

export type FilterA7OPCVMClientPortfoliosSchema = z.infer<
  typeof filterA7OPCVMClientPortfoliosSchema
>;

const initialFields: Field[] = [
  {
    name: "date_equals",
    label: `Date`,
    type: "autocomplete",
    options: [],
  },
  {
    name: "denomination_fonds_contains",
    label: `Fonds`,
    type: "input",
  },
  {
    name: "scope_contains",
    label: `Périmètre`,
    type: "input",
  },
  {
    name: "vehicle_contains",
    label: `Véhicule`,
    type: "input",
  },
];

export function FilterA7OPCVMClientPortfolios({
  table_name,
}: {
  table_name: string;
}) {
  const { fields } = useDateOptions("a7", table_name, initialFields);

  return (
    <FilterTable
      schema={filterA7OPCVMClientPortfoliosSchema}
      tableName="a7_opcvm_client_portfolios"
      fields={fields}
      client="a7"
      customBuildPath={() => `a7-opcvm/${table_name}`}
      excludeFieldsFromConvertDate={["date_equals"]}
    />
  );
}
